module.exports = __webpack_public_path__ + "img/HERO-head-09-motharo.c36ab56d.png";